"use client";

import { TextReveal } from "@/components/motion/text-reveal";
import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "motion/react";

function slideKeyOf(title: string) {
  return title.replace(/\s*\(\s*\d+\s*\/\s*\d+\s*\)\s*$/, "");
}

export function HandyoutBadge({
  title,
  className,
}: {
  title?: string;
  className?: string;
}) {
  const slideKey = title ? slideKeyOf(title) : "";
  return (
    <AnimatePresence mode="wait" initial={false}>
      {title ? (
        <motion.div
          key={slideKey}
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: "auto", opacity: 1 }}
          exit={{ width: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className={cn(
            "inline-block overflow-hidden px-3 py-1 bg-neutral-100 dark:bg-neutral-800 rounded-md",
            className,
          )}
        >
          <TextReveal
            text={title}
            stagger={0.05}
            blur={6}
            yOffset="20%"
            className="text-xs text-neutral-500 dark:text-neutral-400 whitespace-nowrap"
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
